import {notificationSmsService, settlementService} from "../../common/api.service";

const initialStates = {
    status: 'loading',
    form_data: {
        max_amount: '',
        percent:'',
    },
    banking_result_data:{}
}

const mutations = {
    loading(state) {
        state.status    = 'loading'
    },
    success(state, banking_result_data) {
        state.status    = 'success'
        state.banking_result_data = banking_result_data
    },

}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    banking_result_data: ({banking_result_data}) => banking_result_data,

}

const actions = {
    find({commit}) {
        commit('loading')
        return settlementService.findBankingWage().then(response => {
            commit('success', response.data.data)
        })
    }

}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}